import ModalFormWrapper from "../common/ModalFormWrapper";
import HomePayFeeFormStablecoin from "../forms/HomePayFeeFormStablecoin";
import {AvailableBalance} from "../../utils/creditService";

interface HomePayFeeModalViewStablecoinProps {
  onCloseModal: () => void;
  handleBack: () => void;
  creditLine: AvailableBalance;
}

function HomePayFeeModalViewStablecoin(
  {
    onCloseModal,
    handleBack,
    creditLine,
  }:HomePayFeeModalViewStablecoinProps) {
  return (
    <ModalFormWrapper
      headerTitle="Pay fees with stablecoin"
      onClick={handleBack}
      onCloseModal={onCloseModal}
    >

      <HomePayFeeFormStablecoin creditLine={creditLine}/>

    </ModalFormWrapper>
  );
}

export default HomePayFeeModalViewStablecoin;